import { LogEventType } from '@akin-home/amplify';
import { CreateRecordLogEvent } from '@akin-home/logging';
import { postLogEvent, PostLogEventParams } from './postLogEvent';

type Params = Omit<PostLogEventParams<CreateRecordLogEvent['data']>, 'type'>;

export const postCreateRecordLogEvent = (params: Params) =>
  postLogEvent({
    ...params,
    type: LogEventType.CREATE_RECORD,
  });
